import React from 'react';

export default function ListingSubmitted() {
  return (
    <div className="max-w-xl mx-auto bg-white dark:bg-gray-800 shadow rounded-lg p-8 mt-12 text-center">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Thank you for your submission!</h2>
      <p className="text-gray-700 dark:text-gray-300 mb-6">
        Your listing has been submitted and is pending approval. Listings are usually reviewed and published within a few minutes.
      </p>
      <p className="text-gray-700 dark:text-gray-300 mb-6">
        You can view your listing once it has been approved and appears in the listings page.
      </p>
      <a href="/listings" className="inline-block px-6 py-2 bg-orange-600 text-white rounded hover:bg-orange-700 transition">Back to Listings</a>
    </div>
  );
} 